import ThemeToggleButton from "./ThemeToggleButton";
import FontSizeAdjuster from "./FontSizeAdjuster";
import classNames from "classnames";
import {VERSION} from "../config";

const PageFunctions = () => {

  return (
    <div className={'page-fn ml-auto flex flex-nowrap'}>

      <a href="/" className={classNames('fn-home p-2 bg-gray-200 dark:bg-gray-800 text-gray-800 dark:text-gray-200 mb-0')}>
        <svg className={classNames('icon-image')}>
          <use href={`#assets--icons--home`}/>
        </svg>
        <span className={classNames('fn-label')}>Start</span>
      </a>
      <ThemeToggleButton/>
      <FontSizeAdjuster/>
    </div>
  )
}

export default PageFunctions;
